import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "q-pa-md q-gutter-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Please add new comment", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "q-mt-md q-mb-xs label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*"),
  /*#__PURE__*/_createTextVNode(" Choose a date and time for the comment "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-weight-thin" }, "(yyyy/mm/dd hh:mm)")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "main-dropdown-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*"),
  /*#__PURE__*/_createTextVNode(" Event")
], -1 /* HOISTED */)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "row",
  style: {"justify-content":"center"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Shortfall", -1 /* HOISTED */)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "label column q-mb-xs" }
const _hoisted_11 = { class: "field-row q-mb-md" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "label column q-mb-xs" }, " Comment files ", -1 /* HOISTED */)
const _hoisted_13 = { class: "field-row q-mb-md" }
const _hoisted_14 = { class: "column col-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, " WO number ", -1 /* HOISTED */)
const _hoisted_16 = { class: "column q-mb-md q-mt-md col-12" }
const _hoisted_17 = { class: "column" }
const _hoisted_18 = { class: "label q-mt-md" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Author ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_EquipmentHierarchy = _resolveComponent("EquipmentHierarchy")!
  const _component_TradeHierarchy = _resolveComponent("TradeHierarchy")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.getAddLastStatusDialog,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.getAddLastStatusDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "q-pa-sm",
          style: {"width":"700px","max-width":"80vw","overflow":"scroll"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_form, {
              class: "q-gutter-md",
              onSubmit: _ctx.onPreUpdate
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row items-center" }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_q_space),
                    _withDirectives(_createVNode(_component_q_btn, {
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: "",
                      "data-test": "button-close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClose()))
                    }, null, 512 /* NEED_PATCH */), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createVNode(_component_Datepicker)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.selectedEvent,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedEvent) = $event)),
                        options: _ctx.availableEvents,
                        "option-label": "label",
                        "option-value": "value",
                        "map-options": "",
                        "emit-value": "",
                        "bottom-slots": "",
                        outlined: "",
                        "data-test": "event-dropdown",
                        rules: [(val) => !!val || 'Event is required'],
                        "lazy-rules": ""
                      }, null, 8 /* PROPS */, ["modelValue", "options", "rules"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                (_ctx.getEquipmentDetails.failureRootCause)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_ctx.displaySpecificFailure())
                        ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_q_checkbox, {
                                  modelValue: _ctx.equipmentMajorFailure,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.equipmentMajorFailure) = $event)),
                                  "data-test": "equipment-major-failure",
                                  label: "Equipment major failure"
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _createVNode(_component_q_checkbox, {
                                  modelValue: _ctx.gasOrOilLeak,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gasOrOilLeak) = $event)),
                                  "data-test": "gas-oil-leak",
                                  label: "Gas or oil leak"
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _createVNode(_component_q_checkbox, {
                                  modelValue: _ctx.fireConfirmed,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fireConfirmed) = $event)),
                                  "data-test": "fire-confirmed",
                                  label: "Fire confirmed"
                                }, null, 8 /* PROPS */, ["modelValue"])
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      (_ctx.eventDisplayEquipementList())
                        ? (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_EquipmentHierarchy, {
                                onEquipmentPath: _ctx.getEquipmentPath,
                                onEquipmentName: _ctx.getSelectedEquipmentName
                              }, null, 8 /* PROPS */, ["onEquipmentPath", "onEquipmentName"])
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_component_q_card_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_TradeHierarchy)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      (_ctx.showSerialNumberSectionFn())
                        ? (_openBlock(), _createBlock(_component_q_card_section, { key: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_toggle, {
                                modelValue: _ctx.showSerialNumber,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showSerialNumber) = $event)),
                                "checked-icon": "check",
                                color: "green",
                                label: `Serial number changed? Current is ${
                  _ctx.getLastSerialNumberFn.serialNumber
                    ? _ctx.getLastSerialNumberFn.serialNumber
                    : `Unknown`
                }`,
                                "unchecked-icon": "clear"
                              }, null, 8 /* PROPS */, ["modelValue", "label"]),
                              (_ctx.showSerialNumber)
                                ? (_openBlock(), _createBlock(_component_q_input, {
                                    key: 0,
                                    modelValue: _ctx.serialNumber,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.serialNumber) = $event)),
                                    label: "Serial Number",
                                    class: "q-mr-auto",
                                    "data-test": "serial-number"
                                  }, null, 8 /* PROPS */, ["modelValue"]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      (_ctx.displayShortfall())
                        ? (_openBlock(), _createBlock(_component_q_card_section, {
                            key: 3,
                            class: "column"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8,
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_q_input, {
                                  modelValue: _ctx.productionShortfall,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.productionShortfall) = $event)),
                                  label: "Production Shortfall",
                                  "data-test": "production-shortfall",
                                  suffix: _ctx.getProductionShortfallUnit,
                                  class: "q-mr-auto"
                                }, null, 8 /* PROPS */, ["modelValue", "suffix"]),
                                _createVNode(_component_q_input, {
                                  modelValue: _ctx.waterInjectShortfall,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.waterInjectShortfall) = $event)),
                                  label: "Water Inject Shortfall",
                                  "data-test": "waterinject-shortfall",
                                  suffix: _ctx.getWaterInjectShortfallUnit,
                                  class: "q-ml-auto q-mr-auto"
                                }, null, 8 /* PROPS */, ["modelValue", "suffix"]),
                                _createVNode(_component_q_input, {
                                  modelValue: _ctx.flaring,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.flaring) = $event)),
                                  label: "Flaring",
                                  "data-test": "flaring-shortfall",
                                  suffix: _ctx.getFlaringUnit,
                                  class: "q-ml-auto"
                                }, null, 8 /* PROPS */, ["modelValue", "suffix"])
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getStatusToUpdate !== _ctx.equipmentStatusesEnum.RUN &&
                _ctx.getStatusToUpdate !== _ctx.equipmentStatusesEnum.ABNR
                  ? "*"
                  : "") + " Event comment ", 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_q_input, {
                        modelValue: _ctx.comment,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.comment) = $event)),
                        type: "textarea",
                        rows: "1",
                        rules: [(val) => !!val || 'Comment is required'],
                        "lazy-rules": ""
                      }, null, 8 /* PROPS */, ["modelValue", "rules"])
                    ]),
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_q_file, {
                        modelValue: _ctx.files,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.files) = $event)),
                        label: "Select files",
                        multiple: "",
                        append: "",
                        "use-chips": ""
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "cloud_upload" })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.woNumber) = $event)),
                        maxlength: "10",
                        onKeypress: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isNumberCheck($event)))
                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                        [_vModelText, _ctx.woNumber]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_q_checkbox, {
                        modelValue: _ctx.addToWeeklyReport,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addToWeeklyReport) = $event)),
                        label: "Add to weekly report ?"
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      _createVNode(_component_q_checkbox, {
                        modelValue: _ctx.isAlert,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isAlert) = $event)),
                        label: "Display alert ?"
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", null, _toDisplayString(_ctx.author), 1 /* TEXT */)
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_q_card_section, {
                  align: "right",
                  style: {"padding":"0px","margin":"0px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      outline: "",
                      rounded: "",
                      "no-caps": "",
                      label: "Update",
                      class: "action-button",
                      type: "submit"
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onSubmit"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_ConfirmDialog, {
      title: _ctx.confirmPopUpTitle,
      message: _ctx.confirmMessage,
      open: _ctx.datepickerConfirmDialog,
      onOnClose: _ctx.onClose,
      onOnConfirm: _ctx.onConfirm
    }, null, 8 /* PROPS */, ["title", "message", "open", "onOnClose", "onOnConfirm"])
  ]))
}